// Per-dispatch / per-tick working context handed to rules and systems: the state, the compiled defs, the
// event sink, the derived occupancy index and the derived chute topology (both rebuilt for every command and
// every tick, never persisted; the topology is dropped whenever a building is added, removed, moved or
// rotated and rebuilt lazily on the next use — topology.ts).
import type { SimDefs } from './defs.ts';
import type { SimEvent } from './events.ts';
import { buildOcc, type Occ } from './occupancy.ts';
import type { SimState } from './state.ts';
import type { Topo } from './topology.ts';

export interface Ctx {
  s: SimState;
  d: SimDefs;
  ev: SimEvent[];
  occ: Occ;
  /** Lazily built by topology.topoOf; null = stale. */
  topo: Topo | null;
}

export function makeCtx(s: SimState, d: SimDefs, ev: SimEvent[]): Ctx {
  return { s, d, ev, occ: buildOcc(s, d), topo: null };
}
